import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AutomobileMake } from './automobile-make';

@inheritSerialization(AbstractModel)
export class AutomobileModel extends AbstractModel {
  @autoserialize
  name: string;

  @autoserializeAs(AutomobileMake)
  automobileMake: AutomobileMake;
}
